import { styled, useStyletron, withStyle } from "baseui";
import { useGetObjectsInResourceGroupQuery } from "../../services/objects/objectsApi";
import { StyledLink } from "baseui/link";
import { ParagraphXSmall } from "baseui/typography";
import { P_Building } from "@oqdo/automationapps/Plants/Buildings";
import { FormattedMessage } from "react-intl";

export const Items = ({ resourceGroup }) => {
  const [, theme] = useStyletron();
  const { data, isLoading } = useGetObjectsInResourceGroupQuery({
    resourceGroupId: resourceGroup.id,
    modelId: P_Building.MODEL_ID,
  });

  if (isLoading) return <></>;

  return (
    <Container>
      <ParagraphXSmall margin={0} color={theme.colors.primary600}>
        <FormattedMessage id={"buildings"} defaultMessage={"Buildings"} />
      </ParagraphXSmall>
      {data?.map((b) => (
        <Link key={b.id} animateUnderline href={getUrl(b)}>
          {b.description}
        </Link>
      ))}
    </Container>
  );
};

const getUrl = (app) => `https://app.oqdo.io/objects/${app.resourceGroupId}/${app.id}`;

const Container = styled<"div", {}>("div", ({ $theme }) => ({
  display: "flex",
  flexDirection: "row",
  columnGap: $theme.sizing.scale400,
}));

const Link = withStyle(StyledLink, ({ $theme }) => ({
  fontWeight: "normal",
  fontSize: $theme.typography.ParagraphXSmall.fontSize,
}));
